module.exports = __webpack_public_path__ + "img/IMG_3796.fef24f55.jpg";